export const DELIVERY_TYPES = {
  availability: 'availability',
  delivery: 'delivery',
  postamat: 'postamat',
};

export const SHIPPING_GROUP_NAMES = {
  unallocated: 'unallocated',
  soldout: 'soldout',
  delivery: 'delivery',
  thirdparty: 'thirdparty',
  pickup: 'pickup',
};

export const SHIPPING_METHODS = {
  delivery: 'delivery',
  pickup: 'pickup',
  thirdparty: 'thirdparty',
};
